import React from 'react';
import cud from '../cud';

export default React.memo(({children, ...others}) => {
    return (
        <>
            {children}
        </>
    );
});